import BaseSvgIcon from "./BaseSvgIcon";


export const FacebookIconSm = (props) => (
  <BaseSvgIcon width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_234_35841)">
      <path
        d="M13.3312 3.82083H15.1571V0.640833C14.8421 0.5975 13.7587 0.5 12.4971 0.5C9.86458 0.5 8.06125 2.15583 8.06125 5.19917V8H5.15625V11.555H8.06125V20.5H11.6229V11.5558H14.4104L14.8529 8.00083H11.6221V5.55167C11.6229 4.52417 11.8996 3.82083 13.3312 3.82083Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_234_35841">
        <rect width={20} height={20} fill="currentColor" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </BaseSvgIcon>
);

export const InstagramIconSm = (props) => (
  <BaseSvgIcon width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_234_35843)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.75 0.499756H6.25C2.79875 0.499756 0 3.29851 0 6.74975V14.2498C0 17.701 2.79875 20.4998 6.25 20.4998H13.75C17.2013 20.4998 20 17.701 20 14.2498V6.74975C20 3.29851 17.2013 0.499756 13.75 0.499756ZM9.99994 5.49988C7.23869 5.49988 4.99994 7.73863 4.99994 10.4999C4.99994 13.2611 7.23869 15.4999 9.99994 15.4999C12.7612 15.4999 14.9999 13.2611 14.9999 10.4999C14.9999 7.73863 12.7612 5.49988 9.99994 5.49988ZM9.99994 13.6249C8.27744 13.6249 6.87494 12.2224 6.87494 10.4999C6.87494 8.77613 8.27744 7.37488 9.99994 7.37488C11.7224 7.37488 13.1249 8.77613 13.1249 10.4999C13.1249 12.2224 11.7224 13.6249 9.99994 13.6249ZM16.0416 5.12502C16.0416 5.49298 15.7433 5.79126 15.3753 5.79126C15.0073 5.79126 14.7091 5.49298 14.7091 5.12502C14.7091 4.75706 15.0073 4.45877 15.3753 4.45877C15.7433 4.45877 16.0416 4.75706 16.0416 5.12502Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_234_35843">
        <rect width={20} height={20} fill="currentColor" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </BaseSvgIcon>
);

export const TwitterIconSm = (props) => (
  <BaseSvgIcon width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_234_35850)">
      <path
        d="M20 4.29875C19.2563 4.625 18.4637 4.84125 17.6375 4.94625C18.4875 4.43875 19.1363 3.64125 19.4412 2.68C18.6488 3.1525 17.7738 3.48625 16.8412 3.6725C16.0887 2.87125 15.0162 2.375 13.8462 2.375C11.5763 2.375 9.74875 4.2175 9.74875 6.47625C9.74875 6.80125 9.77625 7.11375 9.84375 7.41125C6.435 7.245 3.41875 5.61125 1.3925 3.1225C1.03875 3.73625 0.83125 4.43875 0.83125 5.195C0.83125 6.615 1.5625 7.87375 2.6525 8.6025C1.99375 8.59 1.3475 8.39875 0.8 8.0975C0.8 8.11 0.8 8.12625 0.8 8.1425C0.8 10.135 2.22125 11.79 4.085 12.1712C3.75125 12.2625 3.3875 12.3062 3.01 12.3062C2.7475 12.3062 2.4825 12.2913 2.23375 12.2362C2.765 13.86 4.2725 15.0538 6.065 15.0925C4.67 16.1838 2.89875 16.8412 0.98125 16.8412C0.645 16.8412 0.3225 16.8263 0 16.785C1.81625 17.9563 3.96875 18.625 6.29 18.625C13.835 18.625 17.96 12.375 17.96 6.9575C17.96 6.77625 17.9538 6.60125 17.945 6.4275C18.7588 5.85 19.4425 5.12875 20 4.29875Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_234_35850">
        <rect width={20} height={20} fill="currentColor" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </BaseSvgIcon>
);
